
import { Amplify } from 'aws-amplify';
import { IAuthInterface } from '../../services/interface/user/login/IAuthInterface';
import ConfigService from 'src/services/config/config.service';
import React from 'react';
import { signUp, confirmSignUp, resetPassword, resendSignUpCode, confirmResetPassword } from '@aws-amplify/auth';
import 'aws-amplify/auth/enable-oauth-listener';

const awsConfig = ConfigService.getConfig().awsConfig;

/** Amplify exige que o redirectSignIn tenha a mesma origin da página atual. */
const currentOriginLoginRedirect = `${window.location.origin}/login`;
const oauthRedirectSignIn = Array.from(
	new Set([...(awsConfig.oauthRedirectSignIn || []), currentOriginLoginRedirect])
);
const oauthRedirectSignOut = Array.from(
	new Set([...(awsConfig.oauthRedirectSignOut || []), currentOriginLoginRedirect])
);

Amplify.configure({
	Auth: {
		Cognito: {
			userPoolId: awsConfig.cognitoUserPoolId,
			userPoolClientId: awsConfig.userPoolWebClientId,
			identityPoolId: awsConfig.userPoolIdentityPoolId,
			loginWith: awsConfig.cognitoDomain
				? {
					oauth: {
						domain: awsConfig.cognitoDomain,
						scopes: ['openid', 'email', 'profile'],
						redirectSignIn: oauthRedirectSignIn,
						redirectSignOut: oauthRedirectSignOut,
						responseType: 'code',
						providers: [{ custom: awsConfig.entraIdentityProviderName }],
					},
				}
				: undefined,
		}
	}
});

export const DefaultAuthContextState: IAuthInterface = {
	signUp: async (email: string, password: string) => {
		const lowerCaseEmail = email.toLowerCase();
		return signUp({
			password,
			username: lowerCaseEmail,
			options: {
				userAttributes: {
					email: email.toLowerCase().trim(),
				},
			},
		});
	},

	confirmSignUp: async (email: string, code: string) => {
		return new Promise<any>(async (res, reject) => {
			try {
				res(await confirmSignUp({ username: email.toLowerCase(), confirmationCode: code }));
			} catch (e) {
				if (e.code === 'UnexpectedLambdaException' || e.code === 'NotAuthorizedException') {
					res(true);
				} else {
					reject(e);
				}
			}
		});
	},

	signIn: async (email: string, password: string) => {
		throw new Error("Not implemented")
	},

	signInWithMFA: async (email: string, password: string, mfaCode: string) => {
		throw new Error("Not implemented")
	},

	signInWithMicrosoft: async () => {
		throw new Error("Not implemented")
	},

	completeFederatedMfa: async (_mfaCode: string) => {
		throw new Error("Not implemented")
	},

	signOut: async () => {
		throw new Error("Not implemented")
	},

	requestEmailConfirmation: async (email: string) => {
		return resendSignUpCode({ username: email.toLowerCase().trim() });
	},

	forgotPassword: async (email: string) => {
		return resetPassword({ username: email.toLowerCase().trim() });
	},

	forgotPasswordSubmit: async (email: string, code: string, newPassword: string) => {
		return confirmResetPassword({
			username: email.toLowerCase().trim(),
			confirmationCode: code,
			newPassword
		});
	},

	completeNewPassword: async (user: any, newPass: string) => {
		return null;
	},

	isLoggedIn: () => false,
	hasCurentUser: () => false,
	isEntraLoginAvailable: () => ConfigService.isEntraLoginAvailable(),
	isFederatedMfaPending: () => false,
	isFederatedSignInLoading: () => false,

	currentEmail: undefined,
	currentUser: undefined
};

export const AuthContext = React.createContext<IAuthInterface>(DefaultAuthContextState);
